import React from 'react'
import { Link } from 'react-router-dom'

const PendingActions = ({ count }) => {
  return (
    <div className="col-xl-4 col-lg-6 order-lg-1">
        <div className="card" style={{ height: '350px' }}>
            <div className="card-body pb-0">
                <div className="mb-3">
                    <h4 className="header-title mb-3">Workflow</h4>
                    <div className="d-flex bg-warning mt-2 align-items-center justify-content-between p-1 rounded">
                        <div className="d-flex gap-2 align-items-center">
                            <div className="bg-white fs-5 rounded-circle d-flex align-items-center justify-content-center p-1" style={{ width: '28px', height: '28px'}}>
                                {count}
                            </div>
                            <span className='text-white'>Pending Approval</span>
                        </div>
                        <div>
                            <Link to={'/admin/pending-actions'} className="text-white">
                                <i className='mdi mdi-eye text-white fs-4 mx-2'></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PendingActions